export enum EProtocolSortType {
	label = "label",
	last_update = "lastUpdate",
}
